import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import Filter from 'rp-react-common/Filter';
import FilteringComponent from '../../shared/filter';
import categoriesFactory from './categories';
import columns from './columns';
import getMappedStatistic from './helpers/getMappedStatistic';

const setRowClass = ({ type }) => (type === 'total' ? 'hp-sales-statistic__totalRow' : '');

class SalesStatistic extends FilteringComponent {
    constructor(props) {
        super(props);

        const { overall, saleStatistics, seasonInfo: { countryFlag } } = props.data;

        this.state = {
            data: getMappedStatistic(overall, saleStatistics),
            categories: categoriesFactory(countryFlag, 'yearlings'),
            loading: false,
            fetchError: false,
        };
    }

    buildUrl = ({ displayBy, regions }) => {
        const { id } = this.props.params;
        return `horse/filter/sales-statistics/${id}/${displayBy}/${regions}`;
    };

    onDataReceive = ({ overall, saleStatistics }) => {
        this.setState({
            data: getMappedStatistic(overall, saleStatistics) || this.emptyData,
            loading: false,
        });
    };

    categoriesReducer = categories => categories;

    render() {
        const { data, categories, loading, fetchError } = this.state;
        return (
            <section className="hp-sales-statistic">
                <Filter
                    categories={categories}
                    fetchError={fetchError}
                    categoriesReducer={this.categoriesReducer}
                    onFilterApply={this.onFilterApply}
                />
                {!fetchError && (
                    <RpTable
                        data={data}
                        columns={columns}
                        loading={loading}
                        uiType={6}
                        setRowClass={setRowClass}
                        noDataText="No sales statistics in the Racing Post database for this sire"
                    />
                )}
                <div className="hp-sales-statistic__subtext">
                    All sales prices are shown in English Guineas
                </div>
            </section>
        );
    }
}

const saleTypes = {
    saleYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    byersCount: PropTypes.number,
    offeredCount: PropTypes.number,
    salesCount: PropTypes.number,
    soldPercent: PropTypes.number,
    priceAverage: PropTypes.number,
    priceMax: PropTypes.number,
    median: PropTypes.number,
    priceMin: PropTypes.number,
};

const segmentShape = PropTypes.shape({
    ...saleTypes,
    colts: PropTypes.shape(saleTypes),
    fillies: PropTypes.shape(saleTypes),
});

SalesStatistic.propTypes = {
    data: PropTypes.shape({
        saleStatistics: PropTypes.arrayOf(segmentShape),
        overall: segmentShape,
    }).isRequired,
};

export default SalesStatistic;



// WEBPACK FOOTER //
// ./src/js/horse/salesStatistics/SalesStatistics.jsx